<!-- taro di parent kondisi nya -->
@if (roamingPageData) {
<div class="schedule">
    <div class="schedule__title">
        <label for="schedule-title">{{roamingPageData.header[currentLang()]}}</label>
    </div>
    <div class="schedule__description">
        <label for="schedule-description">{{'roaming.desc' | translate}}</label>
    </div>
    <ul class="schedule__activation-options">
        <li>
            <radio-button (changeEvent)="handleOptionSelected($event)" [options]="radioButtonOptions()" />
        </li>
    </ul>

    @if (optionSelected() === 'resv') {
         <div class="schedule__date-time">
            <date-picker (dateSelected)="dateSelected.set($event)" [label]="'tanggal Pengaktifan'" [placeholder]="'Atur tanggal paket aktif'" />
            <pick-hour (timeSelected)="timeSelected.set($event)" [time]="roamingHoursData()" [label]="'Jam Pengaktifan'" [placeholder]="'Atur jam paket aktif'" />
        </div>
    }


    <button (click)="onClickContinue()" [disabled]="!isButtonValid()" [class.active]="isButtonValid()"
        class="schedule__continue-btn">{{'roaming.continue' | translate}}</button>
</div>
}
